export const PRIMARY_FONT = 'Playfair Display, serif';
